import React, { useEffect, useState } from "react";

import { SketchPicker } from "react-color";

import { Button } from "shared/ui/Button";
import { Modal } from "shared/ui/Modal";

interface ColorPickerDialogProps {
    open: boolean;
    initialColor: string | null;
    title: string;
    onClose: () => void;
    onApply: (color: string) => void;
}

export const ColorPickerDialog = ({
    open,
    initialColor,
    title,
    onClose,
    onApply,
}: ColorPickerDialogProps) => {
    const [color, setColor] = useState<string>(initialColor || "#FFFFFF");

    useEffect(() => {
        if (open) setColor(initialColor || "#FFFFFF");
    }, [open, initialColor]);

    return (
        <Modal
            open={open}
            onClose={onClose}
            maxWidth="xs"
            title={title}
            actions={
                <>
                    <Button variant="outlined" color="neutral" onClick={onClose}>
                        Отмена
                    </Button>
                    <Button variant="contained" onClick={() => onApply(color)}>
                        Выбрать
                    </Button>
                </>
            }
        >
            <SketchPicker
                color={color}
                disableAlpha
                onChange={(next) => setColor(next.hex)}
            />
        </Modal>
    );
};
